import React, { Component } from 'react';
import { connect } from 'react-redux';
import { firebaseConnect, populate, isLoaded } from 'react-redux-firebase';
// import { Link } from 'react-router';
// import Modal from 'react-modal';

import { history } from '../../../store';
// import jobTypes from '../../../data/options_type/job_type.json';
import Loading from '../../../components/elements/loading';
// import NotFound from '../../../components/elements/not-found';
import PanelList from '../../../components/layout/panel-list';
import PanelListItemDuo from '../../../components/layout/panel-list-item-duo';
import CoursesClassesClassView from './class';
// import JobsModalAdd from './modal-job';
// import { modalStyle } from '../../components/layout/modal/modal-style';

// const populateAuthor = [{ child: 'fromID', root: 'users' }];
const populates = [
  { root: 'classes', child: 'classes' },
];
const populateClass = [
  { root: 'modules', child: 'modules' },
  { root: 'members', child: 'users-info' },
];
/* eslint-disable */
@firebaseConnect(
  ({ params }) =>
    [
      { path: `classes/${params.class}`, populates, storeAs: 'clas' },
      { path: `courses/${params.slug}`,  storeAs: 'course' },
      { path: 'classes' },
      { path: 'modules' }
    ]
)
@connect(
  ({ firebase, firebase: { data: { course, clas, classes } } }) => ({
    account: populate(firebase, 'profile', populates),
    course: populate(firebase, 'course', populates),
    class: populate(firebase, 'clas', populateClass)
  })
)
export default class CoursesClassesClass extends Component {

  constructor(props) {
    super(props)
    this.state = {
      modalIsOpen: false,
    }

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleBack = this.handleBack.bind(this)
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }
  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  handleBack() {
    history.push('/courses/' + this.props.params.slug )
  }

  renderClasses(jobs) {
    return Object.keys(jobs).map((job) => {
      return <PanelListItemDuo
            key={ job }
            url={ '/courses/' + this.props.params.slug + '/classes/' + job }
            title={ jobs[job].classID }
            info={ jobs[job].classID } />;
    });

  }

  // renderJob(jobs) {
  //   return Object.keys(jobs).map((job) => {
  //     return (<PanelListItemDuo
  //           key={ job }
  //           url={ '/jobs/' + job }
  //           title={ jobs[job].name }
  //           info={ jobs[job].type } />);
  //   });
  // }

  render() {
    var list;
    if (!isLoaded(this.props.course)) {
      list = ( <Loading /> );
    // } else if (isEmpty(this.props.courses)) {
    //   list = ( <NotFound /> );
    } else {
      list = this.renderClasses(this.props.course.classes);
    }

    return (
      <main className="split">
        <aside>
          <PanelList
            title="Classes"
            color="school"
            actionLeftIcon="icon-arrow-left"
            actionLeft={ this.handleBack }
            actionRight={ this.openModal }
          >
          { list }
          </PanelList>
        </aside>
        <CoursesClassesClassView class={this.props.class} courseID={this.props.params.slug} classID={this.props.params.class} />
      </main>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/courses/classes/index.jsx